import { Component } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-wrapper-panel',
  imports: [FormlyModule, MatFormFieldModule],
  template: `
    <div data-debug="formly-checkbox-wrapper" style="margin: 15px 0">
      <ng-container #fieldComponent></ng-container>
      @if (formControl.errors && (formControl.touched || formControl.dirty)) {
        <mat-error>
          <formly-validation-message [field]="field"></formly-validation-message>
        </mat-error>
      }
    </div>
  `,
})
export class FormlyCheckboxWrapperComponent extends FieldWrapper {}
